import { connect } from "react-redux";
import { useAuth0 } from "../../../auth/react-auth0-spa";
import { AppState } from "../../../state/store";

const mapStateToProps = (state: AppState) => {
  return {
    logoutBoolean: state.authReducer.logout,
  };
};
type Props = Partial<ReturnType<typeof mapStateToProps>>;

const LogoutAuth = (props: Props) => {
  const { logout } = useAuth0();
  const signOut = () => logout({ returnTo: window.location.origin });

  if (props.logoutBoolean === true) {
    signOut();
  }
  return null;
};

export default connect(mapStateToProps, null)(LogoutAuth);
